// @flow

import { connect } from 'react-redux';

import * as ZapImportJob from 'app/entities/ZapImportJob';
import ZapImportModal from 'app/settings/components/ZapImportModal/ZapImportModal';

import { type Dispatch } from 'app/common/types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClose() {
    dispatch(ZapImportJob.actions.unpromptImport());
  },
  onImport(file: File) {
    const messages = { success: 'Import started!', error: 'Import failed!' };
    dispatch(ZapImportJob.actions.importAndNotify({ file }, messages));
  },
});

export default connect(
  null,
  mapDispatchToProps
)(ZapImportModal);
